var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{ref:"list",staticClass:"s-available-positions-app__list"},_vm._l((_vm.jobs),function(job,index){return _c('Job',{key:'job-' + index,attrs:{"job":job}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }